import { Component, ViewEncapsulation } from "@angular/core";
import { TcServices } from "./tc-geneartion.services";
import * as tcGenerationString from "../stringFiles/tcGeneration.json";
import { Router } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

declare var $: any;
declare var customToastr: any;

@Component({
  selector: "app-tc-generation",
  // standalone: true,
  providers: [TcServices],
  // imports: [],
  templateUrl: "./tc-generation.component.html",
  styleUrls: [
    "./tc-generation.component.css",
    "./../../assets/css/theme-default/materialadmin.css",
    "./../../assets/css/theme-default/font-awesome.min.css",
    "./../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css",
    "./../../assets/css/theme-default/material-design-iconic-font.min.css",
    "./../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css",
    "./../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css",
    "./../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css",
    /*'./../../assets/css/theme-default/libs/toastr/toastr.css?1425466569',*/
    "./../../_crop/css/style.css",
    "./../../_crop/css/style-example.css",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class TcGenerationComponent {
  selectedJobId: any = '';
  showTcPreviewPage: Boolean = false;
  tcJobInfo = [];
  tcTemplates = [];
  cancellationJobId: string = "";
  tcGenerated: boolean;
  tcCancelled: boolean;
  loadingData: boolean = true;
  tcCancelling: boolean = false;
  editableTemplate: string = "";
  isUploadingExcel: boolean = false;
  uploadSuccess: boolean = false;
  tcUploadErrors = [];
  uploadingExcelSheet: boolean = false;
  tcJobId: string = "";
  strings: any;
  isRefreshing: boolean = false;
  updatingList: boolean = false;
  studentListForTc: [];
  fetchingStudentList: boolean = false;

  constructor(private tcServices: TcServices, private router: Router, private translate: TranslateService) {
    this.initScript();
    this.strings = tcGenerationString;
    this.fetchJobInfo();
  }

  initScript() {
    $(".after").empty();
    $("#device-breakpoints").remove();
    $(".after").append(
      "<script>function customToastr(message,type){toastr.options.hideDuration = 0;toastr.clear();" +
        "toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;" +
        "toastr.options.positionClass = 'toast-top-right';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;" +
        "toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = 'swing';" +
        "toastr.options.hideEasing = 'swing';toastr.options.showMethod = 'slideDown';toastr.options.hideMethod = 'slideUp';" +
        "toastr[type](message, '');return 0;} </" +
        "script>"
    );
  }

  handleViewButton(jobId: any){
    this.selectedJobId = jobId;
    this.showTcPreviewPage = true;
  }

  handleBackArrowClick() {
    this.selectedJobId = '';
    this.showTcPreviewPage = false;
  }

  // function for fetch scheduled/cancel/pending/inprogress job services
  async fetchJobInfo() {
    try {
      this.updatingList = true;
      const response = await firstValueFrom(
        this.tcServices.fetchScheduledJobInfo()
      );
      const data = response as any;
      if (data.status && data.body) {
        this.tcJobInfo = data?.body?.tcDetails?.tcJobList || [];
        this.tcTemplates = data?.body?.tcDetails?.tcTemplateList || [];
        this.loadingData = false;
        this.updatingList = false;
        this.isRefreshing = false;
      }
    } catch (error) {
      this.tcJobInfo = [];
      this.tcTemplates = [];
      this.loadingData = false;
      this.updatingList = false;
      this.isRefreshing = false;
      if (error?.error?.message) {
        customToastr(error.error.message, this.strings.error);
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
        customToastr(errorMessageTranslation, this.strings.error);
      }
    }
  }

  // function for open for pop for confirmation to cancel job
  openPopUpForJobCancellation(jobId) {
    this.cancellationJobId = jobId;
    $("#cancelJob").modal("show");
  }

  // Api Call for cancel selected job
  async cancelSelectedJob() {
    try {
      this.tcCancelling = true;
      const response = await firstValueFrom(
        this.tcServices.tcJobCancel(this.cancellationJobId)
      );
      const data = response as any;
      if (data.status && data.body) {
        this.closeJobCancellationPopup();
        const successTranslation = await firstValueFrom(this.translate.get('success'));
        customToastr(
          data.body
            ? data.body.message
              ? data.body.message
              : successTranslation
            : successTranslation,
          this.strings.success
        );
      }
      this.fetchJobInfo();
      this.tcCancelling = false;
    } catch (error) {
      this.closeJobCancellationPopup();
      this.tcCancelling = false;
      if (error?.error?.message) {
        customToastr(error.error.message, this.strings.error);
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
        customToastr(errorMessageTranslation, this.strings.error);
      }
    }
  }

  // Function for close pop up for cancellation job
  closeJobCancellationPopup() {
    $("#cancelJob").modal("hide");
  }

  // Function for open pop up for edit selected job
  openPopUpForEditJob(selectedTemplate, jobId) {
    this.editableTemplate = selectedTemplate;
    this.cancellationJobId = jobId;
    $("#editJob").modal("show");
  }

  // Function for close pop up for edit selected job
  closePopUpForEditJob() {
    $("#editJob").modal("hide");
  }

  // Function for download template fot edit
 async downloadTemplateForEdit() {
    const link = document.createElement("a");
    link.href = this.editableTemplate;
    link.download = "template.xls";
    link.click();
    this.closePopUpForEditJob();
    const fileDownloadMessageTranslation = await firstValueFrom(this.translate.get('fileDownloadMessage'));
    customToastr(fileDownloadMessageTranslation, this.strings.success);
    this.cancelSelectedJob();
  }

  // function for download sample excel file
 async  downloadSampleExcelFile(fileLink) {
    if (fileLink) {
      const link = document.createElement("a");
      link.href = fileLink;
      link.download = "sample_document.xls";
      link.click();
      const fileDownloadMessageTranslation = await firstValueFrom(this.translate.get('fileDownloadMessage'));
      customToastr(fileDownloadMessageTranslation, this.strings.success);
    } else {
        const sampleFormatErrorTranslation = await firstValueFrom(this.translate.get('sampleFormatError'));
      customToastr(sampleFormatErrorTranslation, this.strings.error);
    }
  }

  //function for api call for file upload
  async fileUploadExcel(uploadedFile) {
    try {
      this.uploadingExcelSheet = true;
      this.tcUploadErrors = [];
      this.uploadSuccess = false;
      const file = uploadedFile.target.files[0];
       const allowFormats = ['xls', 'xlsx'];
       const fileName = file.name;
       const fileExtension = fileName.split('.').pop().toLowerCase();
       if (!allowFormats.includes(fileExtension)) {
        const fileFormatErrorTranslation = await firstValueFrom(this.translate.get('fileFormatError'));
           customToastr(
               fileFormatErrorTranslation,
               this.strings.error
           );
           return;
       }
      if (!file) {
        const fileUploadErrorMessageTranslation = await firstValueFrom(this.translate.get('fileUploadErrorMessage'));
        customToastr(fileUploadErrorMessageTranslation, this.strings.error);
        return;
      }
      const maxSizeInMB = this.strings.fileSize;
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        customToastr(
          `File size exceeds the limit of ${maxSizeInMB}MB. Please upload a smaller file.`,
          this.strings.error
        );
        return;
      }

     
      const body = {
        lang: this.strings.lang,
      };
      this.openPopUpForUploadingExcel();
      const response = await firstValueFrom(
        this.tcServices.uploadExcel(body, file)
      );
      const data = response as any;
      if (data && data.body) {
        if (data.status) {
          if (data.status_code === 412) {
            this.tcUploadErrors = data.body.errorList
              ? data.body.errorList
              : [];
            this.isUploadingExcel = false;
            this.uploadSuccess = false;
            this.uploadingExcelSheet = false;
          } else {
            this.tcJobId = data.body.jobDetails
              ? data.body.jobDetails.jobId
                ? data.body.jobDetails.jobId
                : ""
              : "";
            this.uploadSuccess = true;
            this.isUploadingExcel = false;
            this.uploadingExcelSheet = false;
            this.fetchJobInfo();
          }
        }
      }
    } catch (error) {
      this.uploadingExcelSheet = false;
      this.isUploadingExcel = false;
      if (error?.error?.message) {
        customToastr(error.error.message, this.strings.error);
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
        customToastr(errorMessageTranslation, this.strings.error);
      }
    }
  }

  // function for open pop for excel upload
  openPopUpForUploadingExcel() {
    $("#uploadingExcel").modal("show");
    this.isUploadingExcel = true;
  }

  // function fot close modal for excel upload
  closePopUpForUploadingExcel() {
    $("#uploadingExcel").modal("hide");
  }

  // Function for api call fetch student list from job info
  async openStudentDetailsForTc(jobId) {
    try {
      this.fetchingStudentList = true;
      this.studentListForTc = [];
      $("#studentDetailsTc").modal("show");
      const response = await firstValueFrom(
        this.tcServices.getStudentListForTc(jobId)
      );
      const data = response as any;
      if (data.status && data.body) {
        this.studentListForTc = data.body.studentDataForJob;
        this.fetchingStudentList = false;
      } else {
        this.studentListForTc = [];
        this.fetchingStudentList = false;
      }
    } catch (error) {
      this.closePopOfStudentList();
      this.studentListForTc = [];
      this.fetchingStudentList = false;
      if (error?.error?.message) {
        customToastr(error.error.message, this.strings.error);
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
        customToastr(errorMessageTranslation, this.strings.error);
      }
    }
  }

  // function for close pop up for student list
  closePopOfStudentList() {
    $("#studentDetailsTc").modal("hide");
  }

  // function for refresh job list
  refreshList() {
    this.isRefreshing = true;
    this.fetchJobInfo();
  }

  // function for navigating student page
  openStudentPage() {
    this.router.navigate(["/groups"]);
  }
}
